import { render, staticRenderFns } from "./FloodClimateChangeRisks.vue?vue&type=template&id=69753605&scoped=true"
import script from "./FloodClimateChangeRisks.vue?vue&type=script&lang=ts"
export * from "./FloodClimateChangeRisks.vue?vue&type=script&lang=ts"
import style0 from "./FloodClimateChangeRisks.vue?vue&type=style&index=0&id=69753605&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69753605",
  null
  
)

export default component.exports